// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

// import '../public/firebase-messaging-sw'

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.VUE_APP_FIREBASE_APP_ID || "",
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || ""
};

// Initialize Firebase
const ready = !!firebaseConfig.projectId;
export const app = ready ? initializeApp(firebaseConfig) : null;
export const analytics = ready && process.env.NODE_ENV === 'production' ? getAnalytics(app) : null;
export const messaging = ready ? getMessaging(app) : null;

// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.register('../public/firebase-messaging-sw');
//   });
// }
